import React from "react";

import type { TableColumnType } from "antd";

import { RightAlignedCell } from "./MidstreamNavigatorTable.styles";
import type { WellContribution } from "./types";
import { calculateFacilityTotals } from "./utils/numberUtils";

interface CustomFacilityHeaderRowProps {
  columns: TableColumnType<WellContribution>[];
  wellContributions: WellContribution[];
}

// Custom header row component for Facility mode totals
export const CustomFacilityHeaderRow: React.FC<CustomFacilityHeaderRowProps> = ({
  columns,
  wellContributions
}) => {
  if (!columns || columns.length === 0) {
    return null;
  }

  const { sumGasRate, sumMonthlyGas } = calculateFacilityTotals(wellContributions);

  return (
    <>
      <tr>
        {columns.map((col, index) => (
          <th key={index}>{col.title}</th>
        ))}
      </tr>
      <tr>
        <th>Facility Total</th>
        <th aria-label="Resource Play Total"></th>
        <th aria-label="Operator Total"></th>
        <th>
          <RightAlignedCell>{sumGasRate}</RightAlignedCell>
        </th>
        <th>
          <RightAlignedCell>{sumMonthlyGas}</RightAlignedCell>
        </th>
        <th aria-label="Percentage Total"></th>
        <th aria-label="Distance Total"></th>
      </tr>
    </>
  );
};
